import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperatorFunction, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { catchErrorLogRet, mapList } from '../common/rest.operators';
import { PeriodType } from '../widget/date-range.widget.model';

import { ObjectDateTransformer } from './coaching-insight.model';
import { ScheduleEventDto } from './schedule.coaching-insight.model';

@Injectable()
export class ScheduleCoachingInsightService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    listEvents<T>(
        project: (
            value: T,
            index: number,
        ) => {
            performerId: number;
            periodTypeId: PeriodType;
            periodStart: Date;
            periodEnd: Date;
        },
    ): OperatorFunction<T, ScheduleEventDto[]> {
        return pipe(
            switchMap((value, index) => {
                const args = project(value, index);
                const params = new HttpParams()
                    .set('periodTypeId', args.periodTypeId.toString())
                    .set('periodStart', args.periodStart.toJSON())
                    .set('periodEnd', args.periodEnd.toJSON());
                return this._http.get(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/schedule/${args.performerId}`,
                    { params },
                );
            }),
            mapList(
                new ObjectDateTransformer({
                    eventDate: null,
                    startDate: 'L',
                    endDate: 'L',
                }),
            ),
            catchErrorLogRet([]),
        );
    }
}
